/**
 * Import from angular core .
 */
import { Component, Input } from '@angular/core';
/**
 * Services imports.
 */
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';
import { FunCollectionService } from './../../common-functions/fun-collection.service';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})

export class InfoComponent {
  @Input() data;

  /**
   * Necessary instances.
   */
  constructor(
    private dss: DataStorageService,
    private masterSer: MasterserviceService,
    private fcs: FunCollectionService,
    public mls: NewLanguageService) { }

  /**
   * Function used to set route or like back screen.
   */
  goBack(): void {
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.dss.suggAssList = [];
    this.dss.selected_suggAssList = [];

    this.masterSer.showWebModal.next(displayObj);

    if (this.data.code === 1030) {
      this.fcs.navigateToHome();
    }
  }
}
